import React, { useState, useEffect}  from 'react';
import trapWithApp from '../Assets/calltoaction.png';
import trapOnly from '../Assets/promo.png';
import EOIModal from './EOIModal';
import EOIModalReferralFactory from './EOIModalReferralFactory';
import Ad from './Ad';
import { Trans, useTranslation } from 'react-i18next';
import { Button, Card, Col, Row } from 'react-bootstrap';

function SalesBanner(props) {
    const { t } = useTranslation();
    const prefix = props.region.cta === 1 ? 'salesBanner.cta1' : 'salesBanner';
    const [show, setShow] = useState(false);

    // slightly different legends depending on the window size
    const [windowWidth, setWindowWidth] = useState(0);
    const updateDimensions = () => {
        const windowWidth = window.innerWidth
        setWindowWidth(windowWidth)
    }

    useEffect(() => { 
        updateDimensions();
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize",updateDimensions);
    }, []);

    const getBodyText = () => {
        let title;
        if (props.region.cta === 1) {
            title = <span><span className='font-weight-bold' style={{color:"red"}}>{t('free')} </span>{t(`${prefix}.title`)}</span>;
        }
        else {
            title = <Trans i18nKey={`${prefix}.title`}/>;
        }

        return (
            <div className='text-sm-left mb-3'>
                <div className="mt-0 mb-3">
                    <h2 className="text-primary mb-2">{title}</h2>
                </div>
                <div className="ml-0 mt-1 mb-2 mr-0">
                    <h4 className="fs-16 text-primary mb-0 mx-0">{
                    windowWidth > 1024 ?
                    <Trans i18nKey={`${prefix}.bodyLarge`}/> :
                    <Trans i18nKey={`${prefix}.bodySmall`}/>
                    }</h4>
                </div>
            </div>   
        );
    }

    const getEOI = () => {
        let eoiProps = {
            show: show,
            handleClose: () => setShow(false),
            region: props.region.name,
        };
        if (props.region.referralFactory) {
            return <EOIModalReferralFactory {...eoiProps}/>;
        }
        else {
            return <EOIModal {...eoiProps}/>;
        }
    }

    const buttonProps = {
        className: 'font-weight-bold text-white w-auto mx-auto',
        id: 'showEOIModal',
        onClick: () => setShow(true),
        size: 'lg',
        variant: 'success'
    };

    const imageProps = {
        className: `sales-banner ${props.region.sponsored && 'sales-banner-sponsored'}`,
        src: props.region.ctaImage === 1 ? trapWithApp : trapOnly,
    };

    return (
        <Row>
            {getEOI()}
            {props.region.sponsored &&
                <Col lg={{span: 6, order: 'last'}}>
                    <Ad small={windowWidth < 992}/>
                </Col>
            }
            <Col>
                <Card style={{ borderColor: "#dedede", borderRight: "0.5rem solid #37cc88" }}>
                    <Row>
                        <Col md='auto'>
                            <Card.Img {...imageProps}/>
                        </Col>
                        <Col className={props.region.cta === 1 && 'px-0'}>
                            <Card.Body className='text-sm-center text-md-left'>
                                {getBodyText()}
                                <Button {...buttonProps}>{t(`${prefix}.share`)}</Button>
                            </Card.Body>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row> 
    );
}

export default SalesBanner;